import { Box } from '@mui/material';
import { WsInputNumber } from 'wisestep-base';

import { SectionHeaders } from './SectionHeaders';
interface EmailCountHeaderProps {
  title: string;
  subTitle: string;
  name: string;
}

export const EmailCountHeader = ({ title, subTitle, name }: EmailCountHeaderProps) => (
  <Box display="flex" flexDirection="column" rowGap={1}>
    <SectionHeaders title={title} subTitle={subTitle} />
    <Box width="25%">
      <WsInputNumber name={name} placeholder="" />
    </Box>
  </Box>
);
